import { useEffect, useState } from 'react';
import {
  PushNotifications,
} from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';
import { Capacitor } from '@capacitor/core';
import { isInsideAppContainer } from './global-utils/vmFunctions/others';

const FirebasePushNotifications = () => {
  const [token, setToken] = useState(null);
  // const [notificationData, setNotificationData] = useState(null);

  useEffect(() => {
    const initializePushNotifications = async () => {
      if (!isInsideAppContainer()) {
        console.warn('Push Notifications are only available on native platforms.');
        return;
      }

      try {
        console.log('Requesting  ...');
        const permission = await PushNotifications.requestPermissions();
        if (permission.receive !== 'granted') {
          alert('Push Notification permissions not granted.');
          return;
        }


        // Add listener for token registration
        PushNotifications.addListener('registration', async (tokenData) => {
          console.log('Device Token:', tokenData.value);
          setToken(tokenData.value);

          // Handle iOS-specific token handling
          if (Capacitor.getPlatform() === 'ios') {
            try {
              const fcmToken = await FCM.getToken();
              console.log('FCM Token for iOS:', fcmToken.token);
              setToken(fcmToken.token);
            } catch (err) {
              console.error('Error getting FCM token for iOS:', err);
            }
          }

          // Subscribe to topics
          try {
            await FCM.subscribeTo({ topic: 'general' });
            // admin - subscribeTo admin, test, visitor
            // visitor - subscribeTo visitor
            // test - subscribeTo test
            console.log('Subscribed to topic: general');
          } catch (err) {
            console.error('Error subscribing to topic:', err);
            alert(`Error subscribing to topic: ${err instanceof Error ? err.message : err}`);
          }
        });

        // if you want tracking you can totally do this

        // Listener for notifications received while the app is active
        // PushNotifications.addListener(
        //   'pushNotificationReceived',
        //   (notification) => {
        //     console.log('Push Notification Received:', notification);
        //     setNotificationData(notification);
        //   }
        // );

        // Listener for notification actions
        // PushNotifications.addListener(
        //   'pushNotificationActionPerformed',
        //   (action) => {
        //     console.log('Notification Action Performed:', action);
        //   }
        // );

        console.log('Push Notification permissions granted!');
        await PushNotifications.register();
      } catch (err) {
        console.error('Error during Push Notifications setup:', err);
      }
    };

    initializePushNotifications().catch((err) => {
      console.error('Unexpected error initializing push notifications:', err);
    });
  }, []);

  return null;
};

export default FirebasePushNotifications;
